<template>
  <mw-dialog ref="dialog" :title="title" :appendToBody="false" size='small_large' :beforeClose="beforeClose">
    <mw-upload-table :action='action'  @dataLoaded='tableDataLoaded'  :limit='limit' :addShow='addShow' :deleteShow='deleteShow'
        :renameShow='renameShow' :downloadShow="downloadShow" :recordsIsCanEdit="recordsIsCanEdit" :sortable='sortable' :defaultParams='defaultParams'   :api='api'/>
  </mw-dialog>
</template>
<script>

export default {
  props: {
    params: {
      type: Object
    }
  },
  data() {
    let me = this;
      let uploadAction = this.mwUrl('/api/business/uploadAttachment');
      if(window.$Env && $Env.uploadAttachmentUrl){
          uploadAction = $Env.uploadAttachmentUrl;
      }
    return {
      action:uploadAction,
      api:'business.listAttachment',
      defaultParams:{
        formId:'',
        businessId:'',
        tempBusinessId:'',
        type:'',
        accept:'',
        batchId:'',
        actId:'',
        secLevel:"",
        departmentId:"",
        commentId:"",
        taskId:"",
        docId:"",
        fullAuthType:"",
        formData:""
      },
      addShow:true,
      deleteShow:true,
      downloadShow:true,
      renameShow:true,
      sortable:true,
      limit:0,
      recordsIsCanEdit:undefined,
      title:$lang("附件管理")

    };
  },
  mounted() {
    setTimeout(()=>{
      this.show();
    },200)
    if(this.params.uploadUrl) this.action = this.params.uploadUrl;
    if(this.params.commentId) this.defaultParams.commentId = this.params.commentId;
    if(this.params.departmentId) this.defaultParams.departmentId = this.params.departmentId;
    if(this.params.taskId) this.defaultParams.taskId = this.params.taskId;
    if(this.params.docId) this.defaultParams.docId = this.params.docId;
    if(this.params.fullAuthType) this.defaultParams.fullAuthType = this.params.fullAuthType;
    if(this.params.formData)this.defaultParams.formData = this.params.formData;
    this.defaultParams.formId=this.params.formId;
    this.defaultParams.businessId=this.params.businessId;
    this.defaultParams.tempBusinessId=this.params.tempBusinessId;
    this.defaultParams.type=this.params.type;
    this.defaultParams.accept=this.params.accept;
    this.defaultParams.batchId=this.params.batchId;
    this.defaultParams.actId=this.params.actId;
    this.defaultParams.secLevel=this.params.secLevel;

    this.recordsIsCanEdit = this.params.recordsIsCanEdit;
    this.limit=this.params.limit||0;
    if(this.params.editable!=null){
      this.addShow=this.params.editable;
      this.deleteShow=this.params.editable;
      this.renameShow=this.params.editable;
      this.sortable=this.params.editable;
    }
    this.downloadShow = !this.params.closeAttachDownload
    this.title=$lang(this.params.title||"附件管理");
  },
  watch: {
    params(val) {
      this.defaultParams.formId=val.formId;
      this.defaultParams.tempBusinessId=val.tempBusinessId;
      this.defaultParams.businessId=val.businessId;
      this.defaultParams.type=this.params.type;
      this.defaultParams.accept=this.params.accept;
      this.defaultParams.batchId=this.params.batchId;
      this.defaultParams.actId=this.params.actId;
      this.defaultParams.secLevel=this.params.secLevel;
      this.defaultParams.fullAuthType=this.params.fullAuthType;
      this.limit=this.params.limit||0;
      if(val.editable!=null){
        this.addShow=val.editable
        this.deleteShow=val.editable
      }
    },
  },
  methods: {
    beforeClose:function(){
      if(this.params.secondfunc){
           this.params.secondfunc.call(this);
      }else{
          this.mwRef('dialog').hide();
      }
    } ,
    tableDataLoaded(data){
         this.params.func(data,this);
    },
    show(){
        this.mwRef('dialog').show();
    }
  }
}
</script>





// WEBPACK FOOTER //
// src/modules/index/components/public-dialog/attachment.vue